// src/modules/finances/routes.js

export default [
    {
        name: "FiscalDocsList",
        path: "finances/docs",
        component: () => import("./views/FiscalDocsList.vue"),
        meta: {
            title: "Fiscal Docs",
            perms: "finances",
            icon: "fa-solid fa-folder-open",
        },
    },
    {
        name: "FiscalDocsCreate",
        path: "finances/docs/create",
        component: () => import("./views/FiscalDocsForm.vue"),
    },
    {
        name: "FiscalDocsUpdate",
        path: "finances/docs/:year",
        component: () => import("./views/FiscalDocsForm.vue"),
    },
    {
        name: "LeadFinances",
        path: "finances/leads",
        component: () => import("./views/LeadFinances.vue"),
        meta: {
            title: "Lead Finances",
            perms: "finances",
            icon: "fa-solid fa-chart-bar",
        },
    },
    {
        name: "ExpenseList",
        path: "finances/expenses",
        component: () => import("./views/ExpenseList.vue"),
        meta: {
            title: "Expenses",
            perms: "finances",
            icon: "fa-solid fa-money-bill-alt",
        },
    },
    {
        name: "ExpenseCreate",
        path: "finances/expenses/create",
        component: () => import("./views/ExpenseForm.vue"),
    },
    {
        name: "ExpenseUpdate",
        path: "finances/expenses/:operation",
        component: () => import("./views/ExpenseForm.vue"),
    },
    {
        name: "ExpenseAccounting",
        path: "finances/expenses/:operation/accounting",
        component: () => import("./views/ExpenseAccounting.vue"),
    },

    {
        name: "IncomingList",
        path: "finances/incomings",
        component: () => import("./views/IncomingList.vue"),
        meta: {
            title: "Incomings",
            perms: "finances",
            icon: "fa-solid fa-money-bill-alt",
        },
    },
    {
        name: "IncomingCreate",
        path: "finances/incomings/create",
        component: () => import("./views/IncomingForm.vue"),
    },
    {
        name: "IncomingUpdate",
        path: "finances/incomings/:operation",
        component: () => import("./views/IncomingForm.vue"),
    },
    {
        name: "IncomingAccounting",
        path: "finances/incomings/:operation/accounting",
        component: () => import("./views/IncomingAccounting.vue"),
    },
];
